import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ToastProvider } from './components/Shared/Toast';
import AppShell from './components/Layout/AppShell';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import TenantManagementPage from './pages/TenantManagementPage';
import LicenseManagerPage from './pages/LicenseManagerPage';
import ProviderAdminsPage from './pages/ProviderAdminsPage';
import BerechtigungenPage from './pages/BerechtigungenPage';
import ToolConnectionsPage from './pages/ToolConnectionsPage';
import InstancesOverviewPage from './pages/InstancesOverviewPage';
import DemoTenantsPage from './pages/DemoTenantsPage';
import ToolUrlAdminPage from './pages/ToolUrlAdminPage';
import ProfilePage from './pages/ProfilePage';
import GraphPage from './pages/GraphPage';

function PrivateRoute() {
  const { token, sessionLoading } = useAuth();
  // Wait for cookie-session probe to complete before redirecting (PINFRA-120)
  if (sessionLoading) return null;
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route element={<PrivateRoute />}>
                <Route element={<AppShell />}>
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/graph" element={<GraphPage />} />
                  <Route path="/admin" element={<AdminPage />}>
                    <Route index element={<Navigate to="tenants" replace />} />
                    <Route path="tenants" element={<TenantManagementPage />} />
                    <Route path="licenses" element={<LicenseManagerPage />} />
                    <Route path="admins" element={<ProviderAdminsPage />} />
                    <Route path="permissions" element={<BerechtigungenPage />} />
                    <Route path="tool-connections" element={<ToolConnectionsPage />} />
                    <Route path="tool-urls" element={<ToolUrlAdminPage />} />
                    <Route path="instances" element={<InstancesOverviewPage />} />
                    <Route path="demo-tenants" element={<DemoTenantsPage />} />
                  </Route>
                </Route>
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
